import React from 'react';
import ReactDOM from 'react-dom/client'; // React 18
import { BrowserRouter } from 'react-router-dom'; // Ensure BrowserRouter is imported
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* Wrap the entire app in BrowserRouter */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
